import React, {useState, useEffect} from "react";
import {Row, Col} from "react-bootstrap";
import axios from "axios";
import moment from 'moment';
import {useHistory} from "react-router-dom";

function CreateAction() {
    const uriTypeParam = "https://bo.influxs.live/StraKingAPI00X/api/actions_params";
    const uriToCreateAction = "https://bo.influxs.live/StraKingAPI00X/api/new_action";
    const [plateforms, setPlateforms] = useState(null);
    const [plateformSelected, setPlateformSelected] = useState({id: ""});
    const [campaign, setCampaign] = useState(null);
    const [campaignSelected, setCampaignSelected] = useState({id: ""});
    const [products, setProducts] = useState(null);
    const [productsSelected, setProductsSelected] = useState({id: ""});
    const [types, setTypes] = useState(null);
    const [typesSelected, setTypesSelected] = useState({id: ""});
    let history=useHistory();

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const [createAction, setCreateAction] = useState({
        idPlateform: "",
        idProduct: "",
        idCampaign: "",
        idActionType: "",
        pubDate: "",
        pubLink: "",
        pubDescription: "",
    });

    useEffect(() => {
        const token = localStorage.getItem('token');
        const contraId = localStorage.getItem('contraId');
        console.log(contraId);
        const api = axios.create({
            baseURL: uriTypeParam,
            headers: {'Authorization': 'Bearer ' + token}
        });

        getTypeParams();


        async function getTypeParams() {
            api.get(uriTypeParam + "/" + contraId).then(
                res => {
                    console.log(res);
                    setCampaign(res.data.campagns);
                    setProducts(res.data.products);
                    setPlateforms(res.data.plateforms);
                    setTypes(res.data.types);
                }
            ).catch(err => {
                alert(err.response.data.message);
            })

        }
    }, []);

    const submitHandler = e => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        const contraId = localStorage.getItem('contraId');
        const api = axios.create({
            baseURL: uriTypeParam,
            headers: {'Authorization': 'Bearer ' + token}
        });
        console.log("sqsdqsd");
        setError("");
        setLoading(true);
        if(createAction.pubDate !=="" &&
            createAction.pubDescription !== "" &&
            createAction.idProduct !== "" &&
            createAction.idActionType !== "" &&
            createAction.idCampaign !== "" &&
            createAction.idPlateform !== "" &&
            createAction.pubLink !== "") {
            const dataToCreateAction = {
                contract:contraId,
                platform: createAction.idPlateform,
                product: createAction.idProduct,
                campaign: createAction.idCampaign,
                action_type: createAction.idActionType,
                date_pub: createAction.pubDate,
                link: createAction.pubLink,
                text: createAction.pubDescription,
                tags:""
            };
            api.post(uriToCreateAction,dataToCreateAction).then(
                res=>{
                    console.log(res);
                    setLoading(false);
                    alert("Action créer avec succès");
                    setCreateAction({...createAction,
                        idCampaign: "",
                        idActionType: "",pubDate: "",pubDescription: "",
                    pubLink: "",idProduct: "",idPlateform: ""});
                }
            ).catch(err =>{
                setError(err.response.data.message);
                alert(err.response.data.message);
                setLoading(false);
            })
        }else{
            setLoading(false);
            setError("Renseignez votre les champs vide !!!");
        }
    }

    const stateSelectionHandlerCampaign = event => {
        const value = event.target.value;
        setCreateAction({...createAction, idCampaign: value});
        setCampaignSelected({...campaignSelected, id: value});
        const stateIndex = campaign.findIndex(state => state.value === value);
        console.log(event.target.value, campaign, "index:", stateIndex);

        console.log("id campaign: " + campaignSelected.id);
    };
    const stateSelectionHandlerProduct = event => {
        const value = event.target.value;
        console.log("id: " + value);
        setCreateAction({...createAction, idProduct: value});
        setProductsSelected({...productsSelected, id: value});
        const stateIndex = products.findIndex(state => state.value === value);
        console.log(event.target.value, products, "index:", stateIndex);
        console.log("id product: " + productsSelected.id);
    };

    const stateSelectionHandlerPlatform = event => {
        const value = event.target.value;
        console.log("id: " + value);
        setCreateAction({...createAction, idPlateform: value});
        setPlateformSelected({...plateformSelected, id: value});
        const stateIndex = plateforms.findIndex(state => state.value === value);
        console.log(event.target.value, plateforms, "index:", stateIndex);
        console.log("id product: " + plateformSelected.id);
    };
    const stateSelectionHandlerTypes = event => {
        const value = event.target.value;
        console.log("id: " + value);
        setCreateAction({...createAction, idActionType: value});
        setTypesSelected({...typesSelected, id: value});
        const stateIndex = types.findIndex(state => state.value === value);
        console.log(event.target.value, types, "index:", stateIndex);
        console.log("id product: " + typesSelected.id);
    };
    return (
        <div className="login_form">
            <form onSubmit={submitHandler}>
                <div className="form-inner">
                    <Row>
                        <Col>
                            <button className="button" onClick={() => {
                                history.push('/contraDetails');
                            }}> retour</button>
                        </Col>
                        <Col>
                            <h2>Créer une action</h2>
                        </Col>
                    </Row>
                    {(error!=="") ? (<div className="error">{error}</div>) : ""}
                    {loading ? (<div className="loader">Loading ....</div>) :(<div></div>)}
                    <Row>
                        <Col>
                            <div className="form-group">
                                <label htmlFor="action">Choix de la campagne</label>
                                <select onChange={stateSelectionHandlerCampaign}>
                                    {
                                        (campaign && campaign.length > 0) && campaign.map((schema, index) => {
                                            return (<option value={schema.id} key={index}> {schema.name}</option>);
                                        })
                                    }
                                </select>
                            </div>
                        </Col>
                        <Col>
                            <div className="form-group">
                                <label htmlFor="action">Choix de la produit</label>
                                <select onChange={stateSelectionHandlerProduct}>
                                    {
                                        (products && products.length > 0) && products.map((schema, index) => {
                                            return (<option value={schema.id} key={index}> {schema.name}</option>);
                                        })
                                    }
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="form-group">
                                <label htmlFor="action">Choix de la plateform</label>
                                <select onChange={stateSelectionHandlerPlatform}>
                                    {
                                        (plateforms && plateforms.length > 0) && plateforms.map((schema, index) => {
                                            return (<option value={schema.id} key={index}> {schema.name}</option>);
                                        })
                                    }
                                </select>
                            </div>
                        </Col>
                        <Col>
                            <div className="form-group">
                                <label htmlFor="action">Choix du type d'action</label>
                                <select onChange={stateSelectionHandlerTypes}>
                                    {
                                        (types && types.length > 0) && types.map((schema, index) => {
                                            return (<option value={schema.id} key={index}> {schema.name}</option>);
                                        })
                                    }
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="form-group">
                                <label htmlFor="link">date publication</label>
                                <input type="date" max={moment().format("YYYY-MM-DD")}
                                       name="datePub"
                                       id="datePub"
                                       onChange={e => setCreateAction({...createAction, pubDate: e.target.value})}
                                       value={createAction.pubDate}/>
                            </div>
                        </Col>
                        <Col>
                            <div className="form-group">
                                <label htmlFor="link">Lien de la publication</label>
                                <input type="text" name="link" id="link"
                                       onChange={e => setCreateAction({...createAction, pubLink: e.target.value})}
                                       value={createAction.pubLink}/>
                            </div>
                        </Col>
                    </Row>
                    <div className="form-group">
                        <label htmlFor="description">Description de la publication</label>
                        <input type="text" name="description" id="description"
                               onChange={e => setCreateAction({...createAction, pubDescription: e.target.value})}
                               value={createAction.pubDescription}/>
                    </div>
                    <input type="submit" value="Valider"/>
                </div>
            </form>
        </div>
    )
}

export default CreateAction;